module.exports = __webpack_public_path__ + "static/media/icon-modelo-receituario.82ed4b96.png";